import { gql } from '@apollo/client';

const SUPPORT_ACCESS_REQUEST_FIELDS = gql`
  fragment SupportAccessRequestFields on SupportAccessRequest {
    id
    requesterId
    requesterEmail
    targetUserId
    targetEmail
    companyId
    reason
    status
    createdAt
    expiresAt
    respondedAt
    accessExpiresAt
    sessionStartedAt
    endedAt
    endedBy
  }
`;

// Super admin portal

export const GET_COMPANY_USERS = gql`
  query GetCompanyUsers($companyId: ID!) {
    companyUsers(companyId: $companyId) {
      id
      email
      name
      firstName
      lastName
      createdAt
      isOwner
      isSuperAdmin
    }
  }
`;

export const GET_SUPPORT_ACCESS_REQUEST = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  query GetSupportAccessRequest($id: ID!) {
    supportAccessRequest(id: $id) {
      ...SupportAccessRequestFields
    }
  }
`;

export const GET_SUPPORT_ACCESS_REQUESTS = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  query GetSupportAccessRequests($companyId: ID!) {
    supportAccessRequests(companyId: $companyId) {
      ...SupportAccessRequestFields
      changeCount
    }
  }
`;

export const REQUEST_SUPPORT_ACCESS = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  mutation RequestSupportAccess(
    $targetUserId: ID!
    $companyId: ID!
    $reason: String
  ) {
    requestSupportAccess(
      targetUserId: $targetUserId
      companyId: $companyId
      reason: $reason
    ) {
      ...SupportAccessRequestFields
    }
  }
`;

export const CANCEL_SUPPORT_ACCESS_REQUEST = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  mutation CancelSupportAccessRequest($id: ID!) {
    cancelSupportAccessRequest(id: $id) {
      ...SupportAccessRequestFields
    }
  }
`;

// Main app

export const START_SUPPORT_SESSION = gql`
  mutation StartSupportSession($requestId: ID!) {
    startSupportSession(requestId: $requestId)
  }
`;

export const GET_MY_SUPPORT_ACCESS_REQUESTS = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  query GetMySupportAccessRequests {
    mySupportAccessRequests {
      ...SupportAccessRequestFields
    }
  }
`;

export const RESPOND_TO_SUPPORT_ACCESS_REQUEST = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  mutation RespondToSupportAccessRequest($id: ID!, $approve: Boolean!) {
    respondToSupportAccessRequest(id: $id, approve: $approve) {
      ...SupportAccessRequestFields
    }
  }
`;

export const END_SUPPORT_ACCESS = gql`
  ${SUPPORT_ACCESS_REQUEST_FIELDS}
  mutation EndSupportAccess($id: ID!) {
    endSupportAccess(id: $id) {
      ...SupportAccessRequestFields
    }
  }
`;

export const GET_SUPPORT_SESSION = gql`
  query GetSupportSession {
    supportSession {
      requestId
      adminEmail
      targetEmail
      accessExpiresAt
      isActive
    }
  }
`;

export const END_SUPPORT_SESSION = gql`
  mutation EndSupportSession {
    endSupportSession {
      redirectUrl
    }
  }
`;
